"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCandidateInfoUrl = "/GetCandidateInfo";
//# sourceMappingURL=GetCandidateInfo.js.map